





















































































































































































































import { Component, Watch, Vue } from 'vue-property-decorator';
import { RequestCalendarFilter } from "@/store/modules/types";

interface Provider {
    id: number;
    name: string;
    specialty: string;
    hospital: string;
    country: string;
    city: string;
    license: string;
    image: string;
    availableToday: boolean;
    urlName: string;
}

interface Country {
    countryId: string;
    name: string;
}

@Component
export default class AppointmentRequest extends Vue {
    urlKey =this.$route.params.k;
    isHospitalPage = this.urlKey? true:false;
    filter: RequestCalendarFilter = this.defaultFilter();

    @Watch("filter", { deep: true })
    onFilterChanged() {
        //console.log(this.filter);
        this.getProviders();
    }
    // Datos reactivos
    filters = {
        country: '',
        specialty: '',
        hospital: '',
        query: ''
    };


    defaultFilter(): RequestCalendarFilter {
        return {
            name: "",
            countryId: "",
            entityId: null,
            specialtyId: null,
            urlKey:this.urlKey,
            pageNumber: 1,
            rowsPerPage: 25

        };
    }

    specialties: any[]=[];
    hospitals:any[]=[];
    hospital:any=null;
    

    countries: Country[] = [
        {
            countryId: "DO",
            name: "Dominican Republic",

        },
        {
            countryId: "PR",
            name: "Puerto Rico",

        },
        {
            countryId: "US",
            name: "United States",
        }
    ];

    providers: Provider[] = [
        /*{
          id: 1,
          name: 'Dra. Mariana Casals',
          specialty: 'Cardiología',
          hospital: 'Clínica del Sol',
          country: 'Argentina',
          city: 'Buenos Aires',
          license: '#459023-AR',
          image: 'https://images.unsplash.com/photo-1559839734-2b71f1536783?w=500',
          availableToday: true
        },
        {
          id: 2,
          name: 'Dr. Roberto Gómez',
          specialty: 'Pediatría',
          hospital: 'Centro Médico ABC',
          country: 'México',
          city: 'Ciudad de México',
          license: '#MX-9921',
          image: 'https://images.unsplash.com/photo-1622253692010-333f2da6031d?w=500',
          availableToday: false
        },
        {
          id: 3,
          name: 'Dra. Laura Schmidt',
          specialty: 'Dermatología',
          hospital: 'Fundación Santa Fe',
          country: 'Colombia',
          city: 'Bogotá',
          license: '#COL-8827',
          image: 'https://images.unsplash.com/photo-1594824476967-48c8b964273f?w=500',
          availableToday: true
        }*/
    ];

    // Listas para los selects basadas en los datos
    get countries2(): string[] {
        return [...new Set(this.providers.map(p => p.country))];
    }
/*
    get specialties(): string[] {
        return [...new Set(this.providers.map(p => p.specialty))];
    }
*/



     async getSpecialtyList() {
        this.$store.commit("main/SET_LOADING", true);
        try {
            this.specialties = await this.$store.dispatch("schedule/getRequestSpecialtyList");
        } catch (error) {
            console.log(error);
        } finally {
            this.$store.commit("main/SET_LOADING", false);
        }
    }
    /*
    get hospitals(): string[] {
        return [...new Set(this.providers.map(p => p.hospital))];
    }
*/
     async getEntityList() {
        this.$store.commit("main/SET_LOADING", true);
        try {
            this.hospitals = await this.$store.dispatch("schedule/getRequestEntityList",this.filter.countryId);
        } catch (error) {
            console.log(error);
        } finally {
            this.$store.commit("main/SET_LOADING", false);
        }
    }

    async getEntityt() {
        this.$store.commit("main/SET_LOADING", true);
        try {
            this.hospital = await this.$store.dispatch("schedule/getRequestEntity", this.urlKey);
        } catch (error) {
            console.log(error);
        } finally {
            this.$store.commit("main/SET_LOADING", false);
        }
    }
    // Lógica de filtrado
    /*
    get filteredProviders(): Provider[] {
        return this.providers.filter(p => {
            const matchCountry = !this.filters.country || p.country === this.filters.country;
            const matchSpecialty = !this.filters.specialty || p.specialty === this.filters.specialty;
            const matchHospital = !this.filters.hospital || p.hospital === this.filters.hospital;
            const matchQuery = !this.filters.query || p.name.toLowerCase().includes(this.filters.query.toLowerCase());

            return matchCountry && matchSpecialty && matchHospital && matchQuery;
        });
    }
*/
    async getProviders() {
        this.$store.commit("main/SET_LOADING", true);
        try {
            const calendars = await this.$store.dispatch("schedule/getRequestCalendarList", this.filter);


            this.providers = (calendars || []).map((c: any, index: number) => ({
                id: c.id ?? index + 1,
                name: c.providerName ?? c.name ?? '',
                specialty: c.specialty ?? '',
                hospital: c.entityName ?? c.hospital ?? '',
                country: c.country ?? '',
                city: c.city ?? '',
                license: c.license ?? '',
                image: c.image
                    ? this.getLogoURL(c.image)
                    : require('@/assets/avatar_3.png'),
                availableToday: c.availableToday ?? false,
                urlName: c.calendarUrlName,
                routeType:c.routeType
            }));
        } catch (error) {
            console.log(error);
        } finally {
            this.$store.commit("main/SET_LOADING", false);
        }
    }

     async setCountry() {
        this.$store.commit("main/SET_LOADING", true);
        try {
            const location = await this.$store.dispatch("schedule/getRequestLocation");
              this.filter.countryId = location["country"];
        } catch (error) {
            console.log(error);
        } finally {
            this.$store.commit("main/SET_LOADING", false);
        }
    }

    getLogoURL(id) {
        return process.env.VUE_APP_ROOT_API + "/schedule/wmpc/content/file/" + id;
    }


    requestAppointmentx(key: string, routeType: string): void {

        console.log('actual:', this.$route.params.c);
console.log('nuevo:', key);

  const routeMap = {
    HO: "entityRequest",
    ST: "calendarRequest"
  };

  const routeName = routeMap[routeType] || "calendarRequest";

  if (this.$route.name === routeName && this.$route.params.c === key) return;

  this.$router.push({
    name: routeName,
    params: { c: key }
  });
}


    requestAppointment(key: string, routeType: string): void {
        console.log("routeType: " + routeType);
        if(routeType == "HO"){
          const  path = `/request/hospital/${key}`;
            //this.$router.push(path).catch(() => {});
            this.$router.push(path).then(() => {
  window.location.reload();
});
            

        /*  this.$router.push({
            name: 'entityRequest',
            params: { c: key }
        });*/
        }else{

             this.$router.push({
            name: 'calendarRequest',
            params: { c: key }
        });
        }
       
    }

    mounted() {
        // if (!this.list.totalRows) 
         //console.log("test" + this.urlKey);
        this.filter = this.defaultFilter();
        //this.getProviders();
        if(this.isHospitalPage){
            this.getEntityt()
        }else{
           this.setCountry(); 
           this.getEntityList();
        }
        
        this.getSpecialtyList();
        
    }
}

